(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    if ('IntersectionObserver' in window && !reduced.matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('ec-pending');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      root.querySelectorAll('[data-ec-reveal]:not([data-ec-observed])').forEach(el => {
        el.dataset.ecObserved = 'true';
        // Already-visible content stays visible; only later sections reveal on entry.
        if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('ec-pending');
        observer.observe(el);
      });
      document.documentElement.classList.add('ec-ready');
    }
    root.querySelectorAll('.ec-motion-toggle:not([data-ec-bound])').forEach(button => {
      button.dataset.ecBound = 'true';
      button.addEventListener('click', () => {
        const paused = button.closest('.ec-ticker').classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('.ec-mobile-menu[open]');
    if (event.key === 'Escape' && menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.ec-mobile-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.ec-pending').forEach(el => el.classList.remove('ec-pending'));
  });
})();
